import { contract_tab, info_tab, versioning_tab } from '../../../../../../views/contract/agreement';

export default {
  title: 'Kontraktoplysninger',
  tabs: {
    [info_tab]: 'Info',
    [contract_tab]: 'Kontrakt',
    [versioning_tab]: 'Versionering',
  },
  sections: {
    price_info: 'Prisinfo',
    contact: 'Nuværende kontrakt',
    signature_history: 'Underskriftshistorik',
  },
  labels: {
    not_signed: 'Kontrakten er endnu ikke underskrevet',
  },
  modals: {
    preview_contract: {
      title: 'Vis kontrakt',
    },
    switch_to_annual: {
      title: 'Skift til årlig',
    },
  },
  buttons: {
    save: 'Gem',
    preview_and_sign: 'Vis og underskriv',
    download: 'Download',
    switch_to_annual: 'Skift til årlig',
  },
  toasts: {
    failed_to_load_data: 'Data kunne ikke indlæses',
    failed_to_save_changes: 'Ændringerne kunne ikke gemmes',
    changes_got_saved: 'Ændringerne blev gemt',
  },
};
